import React from 'react';
import get from 'lodash/get';
import find from 'lodash/find';
import classnames from 'classnames';
import { connect } from 'react-redux';
import {Alert, Icon, Layout, List, Badge, Button, Switch, message, Row, Col, Breadcrumb} from 'antd';

import AdminHeader from '../../components/AdminHeader/AdminHeader';
import SettingsUserRoleForm from '../../components/SettingsUserRoleForm/SettingsUserRoleForm';
import Footer from '../../components/Footer/Footer';

import isAuthenticated from '../../utils/isAuthenticated';
import {getSettingsRolesRequest, getSettingsUserSingleRequest, getSettingsSitesRequest} from '../../api/requests';
import {logout, setPermissions} from "../../reducers/user/actions";
import {getRoleCreatePermission, getUserToken} from "../../reducers/user/selectors";

import classes from './SettingsUserRoles.css';

const routes = require('../../routes.json');

const { Content } = Layout;

class SettingsUserRoles extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      rolesList: [],
      sitesList: [],
      errorMessage: '',
      responseMessage: '',
      roleEdit: null,
      selectedRole: null,
      user: {},
    };
  }

  async componentDidMount() {
    this.getUser();
    this.getRolesList();
    this.getSitesList();
  }

  getUser = async () => {
    this.setState({ errorMessage: null, isLoading: true, responseMessage: null });

    try {
      const { data } = await getSettingsUserSingleRequest(get(this.props, 'match.params.userID'));
      this.setState({ user: data });
    } catch (e) {
      if (get(e, 'response.status') === 401) { this.props.logout();  return; }
      this.setState({ subject: null, errorMessage: get(e, 'response.data.error', 'Error') });
    }

    this.setState({ isLoading: false });
  };

  getSitesList = async () => {
    try {
      const { data } = await getSettingsSitesRequest({});
      this.setState({ sitesList: data });
    } catch (e) { if (e.response && e.response.status === 401) { this.props.logout();  return; } console.log(e); }
  };

  getRolesList = async () => {
    this.setState({ errorMessage: null, isLoading: true, responseMessage: null });

    try {
      const { data } = await getSettingsRolesRequest();
      this.setState({ rolesList: data });
    } catch (e) {
      if (get(e, 'response.status') === 401) { this.props.logout();  return; }
      this.setState({ subject: null, errorMessage: get(e, 'response.data.error', 'Error') });
    }

    this.setState({ isLoading: false });
  };

  onSelectRole = role => () => {
    this.setState({ selectedRole: null }, () => { this.setState({ selectedRole: role }) });
  };

  onRoleEditHide = () => {
    this.setState({ selectedRole: null });
  };

  onRoleEditSubmit = async (roleID) => {
    this.props.setPermissions(this.props.userToken);
    await this.getUser();

    this.setState({ selectedRole: null }, () => { this.setState({ selectedRole: find(get(this.state.user, 'site_access_list', []), roleItem => roleItem.id === roleID) })});
  };

  onAddRole = () => {
    this.setState({ selectedRole: null }, () => { this.setState({ selectedRole: {} }) });
  };

  render() {
    const { rolesList, sitesList, errorMessage, responseMessage, isLoading, selectedRole, user } = this.state;
    const { roleCreatePermission } = this.props;

    return (
        <div style={{ backgroundColor: '#FAFAFA' }}>
            <Layout className={classes.parentContainer}>
                <AdminHeader />
                <Content className={classes.content}>
                  <h3 className='headline-default'>User roles for {get(user, 'username', <Icon type="loading" />)}</h3>

                  <Breadcrumb>
                    <Breadcrumb.Item href='/admin/settings'>Admin Settings</Breadcrumb.Item>
                    <Breadcrumb.Item href='/admin/settings/users'>User Management</Breadcrumb.Item>
                    <Breadcrumb.Item>User Role Management</Breadcrumb.Item>
                  </Breadcrumb>
                  <br/>

                  <Row gutter={24}>
                    <Col lg={6}>
                      <p><b>Select a site and role to edit</b></p>

                      <List
                        className={classes.rolesList}
                        bordered
                        dataSource={get(user, 'site_access_list', [])}
                        renderItem={item => (
                          <List.Item className={classnames(classes.roleItem, { [classes.active]: item.id === get(selectedRole, 'id') })} onClick={this.onSelectRole(item)}>
                            {get(item, 'site.name')} - {get(item, 'user_role.name')}

                            <Badge count={item.state} style={{ backgroundColor: item.state === 'active' ? '#49c850' : '#f00' }} />
                          </List.Item>
                        )}
                      />

                      {roleCreatePermission && <div className={classes.roleActionWrapper}><Button type='primary' onClick={this.onAddRole}>Add role</Button></div>}
                    </Col>

                    <Col lg={18}>
                      <p>&nbsp;</p>

                      {/*{isLoading && <Icon type="loading" />}*/}

                      {selectedRole && <SettingsUserRoleForm
                        selectedRole={selectedRole}
                        userID={get(user, 'id')}
                        isNew={selectedRole && !selectedRole.id}
                        onSubmit={this.onRoleEditSubmit}
                        onCancel={this.onRoleEditHide}
                        rolesList={rolesList}
                        sitesList={sitesList}
                      />}
                    </Col>

                  </Row>

                  {errorMessage && (<Alert type='error' message={errorMessage} />)}

                  {responseMessage && (<Alert type='success' message={responseMessage} />)}

                </Content>
                <Footer noAdminLink />
            </Layout>
        </div>
    );
  }
}

const mapStateToProps = (state) => ({
  roleCreatePermission: getRoleCreatePermission(state),
  userToken: getUserToken(state),
});

const mapDispatchToProps = { logout, setPermissions };

export default isAuthenticated(connect(mapStateToProps, mapDispatchToProps)(SettingsUserRoles));



// WEBPACK FOOTER //
// ./src/containers/SettingsUserRoles/SettingsUserRoles.js